
export const getFilterButtonsConfig = (onFilterTest, onFilter) => [
  {
    func: onFilter,
    icon: 'filter_list',
    name: 'Filtros',
    isDropdown: true,
    dropdownItems: [{
      dropDownItemFuc: onFilter,
      dropdownItemName: 'Filtrar datos reales',
      dropDownItemValue: ''
    },{
      dropDownItemFuc: onFilterTest,
      dropdownItemName: 'Filtrar data de prueba',
      dropDownItemValue: ''
    }],
    isDisabled: false
  }
];